import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import {
  bridgeMenuItems,
  clickBridgeMenuItem,
  observeBridgeMenuChanges,
  stopObservingBridgeMenuChanges
} from "../../src/bridge_menu_items"

// TitleMenuComponent - Turns the native nav bar title into a button with a
// chevron that opens a menu (e.g. switching routines).
//
// The container element carries:
//   data-bridge--title-menu-title-value  text shown in the nav bar
//
// Item attributes are documented in src/bridge_menu_items.js. Native replies
// to "connect" with `{ index }` when an entry is tapped; we click the matching
// item element.
//
// A morph refresh can change the title or items without reconnecting this
// controller, so any change inside the element re-sends "connect".
// "disconnect" restores the plain title, e.g. when a refresh renders the
// screen without a title menu.
export default class extends BridgeComponent {
  static component = "title-menu"
  static targets = ["item"]
  static values = { title: String }

  connect() {
    super.connect()
    observeBridgeMenuChanges(this, () => this.#sendConnect())
    this.#sendConnect()
  }

  disconnect() {
    stopObservingBridgeMenuChanges(this)
    this.send("disconnect")
    super.disconnect()
  }

  #sendConnect() {
    const items = bridgeMenuItems(this.itemTargets)

    this.send("connect", { title: this.titleValue, items }, (message) => {
      clickBridgeMenuItem(this.itemTargets, message)
    })
  }
}
